import { _CoreInputWrapper } from "./inputStyles";
export default _CoreInputWrapper;